import { setCheckoutOverlay } from "@/actions/ui";
import { navigate } from '../helpers/navigationService';
import { deleteReservation } from "@/actions/reservation";
import { refetchMember, setEmail, setName } from "@v/member/actions/member";
import request from "superagent";

export const setAuthStarted = (value) => ({ type: "SET_AUTH_STARTED", value })
export const loginPage = () => (dispatch, getState) => {
    const state = getState();
    const overlay = state.ui.overlay;

  if (!overlay) {
    dispatch(setCheckoutOverlay(true));
  }
  navigate('/auth');
};

export const login = (email: string, first_name: string = '', last_name: string = '', isCheckoutSSO = false) => (dispatch, getState) => {
    const state = getState();
    if (state.reservation?.token) {
        dispatch(refetchMember());
    }
    dispatch({ type: 'LOGIN', email, first_name, last_name, isCheckoutSSO});

    if(first_name !== '' && last_name !== '')
    {
        dispatch(setName(first_name + ' ' + last_name));
    }

    if(email !== '') {
        dispatch(setEmail(email));
    }
}

export const logout = () => (dispatch, getState) => {
    const { ui } = getState();

    const url = ui.styleVars.GLOBAL__PARTNER__URL + '/sso/logout';
    request.post(url)
        .set('Content-Type', 'application/json')
        .send()
        .then(res => {
            if ((res.body) && (res.body.success)) {
                dispatch(deleteReservation());
                dispatch({ type: 'LOGOUT' });
            }
        });
};

